import { useEffect, useState, FC } from "react";
import { Formik, Form } from "formik";
import {
    SelectChangeEvent,
    Button,
    Grid,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    ListItemText,
    TextField,
    Autocomplete,
    Modal,
    Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import * as actions from "../../../store/insituExtractor/actions";
import { DataField } from "../../atoms";
import * as functions from "../../shared/functions";
import { IFormField } from "../../shared/globalTypes";
import Back from "../../atoms/backButton";
import * as constants from "../../../constants/_pickerValues";
import Skeleton from "@mui/material/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import { IUser } from "../../../store/groups/types";
import {
    getProfileDataSelector,
    getRoleClaimsSelector,
} from "../../../store/auth/selectors";
import React from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { getInsituExtractorDetailsPendingSelector, getInsituExtractorDetailsSelector, postInsituExtractorSelector, putInsituExtractorSelector } from "../../../store/insituExtractor/selectors";
import { fetchInsituExtractorDetailsReq, postInsituExtractorReset, putInsituExtractorReset } from "../../../store/insituExtractor/actions";
import { getGroupPendingSelector, getGroupUsersSelector } from "../../../store/groups/selectors";
import { IDP_USERS_PRODUCTION } from "../../../constants/common";
import ExtractorExplorer from "../extractorExplorer/ExtractorExplorer";
import { convertUTCDateToLocalDate } from "../../shared/functions";


// Form fields object
export interface IInsituExtractorFields {

    username: IFormField;
    dataset: IFormField;
    criticality: IFormField;
}

// Instantiating insitu's initial state

let InsituExtractorInitialState: IInsituExtractorFields = {
    username: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    dataset: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
    criticality: { fieldValue: "", isError: false, errorMsg: "", isNumber: true },
};

// mode for determining if form is for add, edit or view

interface Props {
    mode?: string;
}

export const InsituExtractorForm: FC<Props> = ({
    mode = constants.MODE.add,
}: Props) => {
    const dispatch = useDispatch();
    const postInsituExtractor = useSelector(postInsituExtractorSelector)
    const idpUsersProduction = useSelector(getGroupUsersSelector(IDP_USERS_PRODUCTION));
    const idpUsersProductionPending = useSelector(getGroupPendingSelector(IDP_USERS_PRODUCTION));
    const roles = useSelector(getRoleClaimsSelector); // roles  - IDP.Admin or IDP.User
    const getInsituExtractor = useSelector(getInsituExtractorDetailsSelector)
    const getInsituExtractorPending = useSelector(getInsituExtractorDetailsPendingSelector)
    const putInsituExtractor = useSelector(putInsituExtractorSelector)
    const [insituExtractorFormData, setInsituExtractorFormData] = useState(
        InsituExtractorInitialState
    );
    const [disableSaveBtn, setDisableSaveBtn] = useState(true);

    const [insituNavigation, setInsituNavigation] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [createdBy, setCreatedBy] = useState("");
    const [createdOn, setCreatedOn] = useState('');
    const [updatedBy, setUpdatedBy] = useState("");
    const [updatedOn, setUpdatedOn] = useState('');
    const [tableError, setTableError] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [autocompleteOpen, setAutocompleteOpen] = useState(false);
    const { batchCode } = useParams();
    const navigate = useNavigate();

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        resetFields();
    }, []);

    const resetFields = () => {
        setInsituExtractorFormData(prevState => ({
            ...prevState,
            dataset: {
                ...prevState.dataset,
                isError: prevState.dataset.fieldValue === ""
            },
            criticality: {
                ...prevState.criticality,
                isError: prevState.criticality.fieldValue === ""
            },
            username: {
                ...prevState.username,
                isError: prevState.username.fieldValue === ""
            }
        }));
        dispatch(postInsituExtractorReset());
        dispatch(putInsituExtractorReset());
    };

    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
    }, [roles]);

    useEffect(() => {
        if (postInsituExtractor !== null && postInsituExtractor !== undefined && insituNavigation) {
            navigate(`/ViewInsituExtractor/${postInsituExtractor.id}`)
            setInsituNavigation(false);
        }
    }, [postInsituExtractor]);


    useEffect(() => {
        if (putInsituExtractor !== null && putInsituExtractor !== undefined && insituNavigation) {
            navigate(`/ViewInsituExtractor/${batchCode}`)
            setInsituNavigation(false);
        }
    }, [putInsituExtractor]);

    useEffect(() => {
        if (
            (mode === constants.MODE.edit || mode === constants.MODE.view) &&
            getInsituExtractor
        ) {
            insituExtractorFormData.dataset.fieldValue = getInsituExtractor["datasetName"];
            insituExtractorFormData.criticality.fieldValue = getInsituExtractor["criticality"];
            insituExtractorFormData.username.fieldValue = getInsituExtractor["createdBy"];
            setCreatedBy(getInsituExtractor.createdBy)
            setUpdatedBy(getInsituExtractor.updatedBy)
            setUpdatedOn(convertUTCDateToLocalDate(getInsituExtractor?.updatedDate).toString());
            setCreatedOn(convertUTCDateToLocalDate(getInsituExtractor?.createdDate).toString());
            setInsituExtractorFormData(insituExtractorFormData);

        } else {
            insituExtractorFormData.dataset.fieldValue = "";
            insituExtractorFormData.criticality.fieldValue = "";
            insituExtractorFormData.username.fieldValue = "";
            setInsituExtractorFormData(insituExtractorFormData);
        }
    }, [getInsituExtractor, mode]);


    useEffect(() => {
        // When batchCode is available, when it is either VIEW or EDIT

        if (mode !== constants.MODE.add && batchCode) {
            dispatch(fetchInsituExtractorDetailsReq(batchCode));
        }
    }, [batchCode]);


    const goBack = () => {
        resetFields();
        window.history.back();
    };


    const onSelectTable = (dataset: string) => {
        insituExtractorFormData.dataset.fieldValue = dataset;
        setInsituExtractorFormData(insituExtractorFormData);
    };

    const tableSelectorstyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 1300,
        background: "white",
        height: 700,
        p: 4,
        overflowY: "auto",
    };

    // Update fieldValue when it is changed; needed to update the UI of the text fields, text areas
    // Clean value if the field changed is data source

    const handleChange = (event: {}) => {
        const e = event as React.ChangeEvent<HTMLInputElement>;
        (e.target.value === "" || !e.target.value) ? setTableError(true) : setTableError(false);
        setInsituExtractorFormData({
            ...insituExtractorFormData,
            [e.target.name]:
                e.target.name === "dataset"
                    ? functions.getFormField(
                        functions.cleanName(e.currentTarget.value, "")
                    )
                    : functions.getFormField(e.currentTarget.value),
        });

    };

    const handleDropdownChange = (e: SelectChangeEvent<string>) => {
        setInsituExtractorFormData({
            ...insituExtractorFormData,
            [e.target.name]: functions.getFormField(e.target.value),
        });
    };

    //validate
    const validate = () => {
        setInsituExtractorFormData(prevState => ({
            ...prevState,
            dataset: {
                ...prevState.dataset,
                isError: prevState.dataset.fieldValue === ""
            },
            criticality: {
                ...prevState.criticality,
                isError: prevState.criticality.fieldValue === ""
            },
            username: {
                ...prevState.username,
                isError: prevState.username.fieldValue === ""
            }
        }));

        const validateKeys = [
            "criticality",
            "dataset"
        ];

        var data = Object.fromEntries(
            Object.entries(insituExtractorFormData).filter(([key]) =>
                validateKeys.includes(key)
            )
        );

        setInsituExtractorFormData(insituExtractorFormData);


        var insituExtractorFormDataError = Object.values(data as IInsituExtractorFields).filter(
            (x: IFormField) => x.isError === true || x.fieldValue === ""
        );

        if (insituExtractorFormDataError.length > 0) {
            setDisableSaveBtn(true);
        } else {
            setDisableSaveBtn(false);
        }
    };

    useEffect(() => {

        validate();
        if (mode === constants.MODE.edit) {
            setDisableSaveBtn(false);
        }

    }, [insituExtractorFormData]);


    function createNewInsituExtractor() {
        // Setup payload for POST insitu endpoint
        if (mode === constants.MODE.add) {
            let payload = {
                criticality: Number(insituExtractorFormData.criticality.fieldValue),
                datasetName: insituExtractorFormData.dataset.fieldValue,
                createdBy: insituExtractorFormData.username.fieldValue
            }
            dispatch(actions.postInsituExtractorRequest(payload));
            setInsituNavigation(true);
        }
        if (mode === constants.MODE.edit) {
            // put insitu Extractor

            let payload = {
                criticality: Number(insituExtractorFormData.criticality.fieldValue),
                datasetName: insituExtractorFormData.dataset.fieldValue,
                createdBy: insituExtractorFormData.username.fieldValue
            }
            dispatch(actions.putInsituExtractorRequest(batchCode!, payload));
            setInsituNavigation(true);
        }
    }

    const editInsituCriticality = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/EditInsituExtractor/${batchCode}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    };

    return (
        <>
            <Formik initialValues={{}} onSubmit={() => { }}>
                <div>
                    <Back />
                    <h1 style={{ textAlign: "left" }}>{mode} InSitu Extractor</h1>
                    <Form>
                        {/* adding skeleton screen on loading */}
                        {(mode === constants.MODE.view ||
                            mode === constants.MODE.edit) &&
                            getInsituExtractorPending && !idpUsersProductionPending ? (
                            <Box>
                                <Grid container spacing={4}>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Skeleton animation="wave" height={60} />
                                    </Grid>
                                </Grid>
                            </Box>
                        ) : (
                            <>
                                <Grid container spacing={4}>
                                        <Grid item xs={6}>
                                            <FormControl
                                                sx={{ m: 1 }}
                                                fullWidth
                                                variant={
                                                    mode === constants.MODE.view ? "standard" : "outlined"
                                                }
                                            >
                                                {mode !== constants.MODE.view ? (
                                                    <>
                                                        <Box>
                                                            <DataField id="datasetOptions"
                                                                name="tableId"
                                                                label="Select Dataset"
                                                                required
                                                                error={tableError}
                                                                value={insituExtractorFormData.dataset.fieldValue}
                                                                onChange={handleChange}
                                                                onClick={handleOpen}
                                                            />
                                                        </Box>
                                                        <Modal
                                                            open={open}
                                                            onClose={handleClose}
                                                            aria-labelledby="modal-modal-title"
                                                            aria-describedby="modal-modal-description"
                                                            sx={{ overflowY: "auto" }}
                                                        >
                                                            <Box
                                                                sx={tableSelectorstyle}>
                                                                <ExtractorExplorer
                                                                    selectable={"single"}
                                                                    selectedValue={insituExtractorFormData.dataset.fieldValue}
                                                                    onSelect={onSelectTable}
                                                                    displayIcons={false}
                                                                    displayActionButtons={false}
                                                                />
                                                                <Typography
                                                                    id="modal-modal-description"
                                                                    sx={{ mt: 2, mb: 2 }}
                                                                />
                                                                <Box
                                                                    display="flex"
                                                                    justifyContent="flex-end"
                                                                >
                                                                    <Button id="btnHandleClose"
                                                                        color="primary"
                                                                        variant="contained"
                                                                        onClick={handleClose}
                                                                    >
                                                                        Close
                                                                    </Button>
                                                                    <Button id="btnSelect"
                                                                        color="primary"
                                                                        variant="contained"
                                                                        onClick={handleClose}
                                                                        sx={{ ml: 1 }}
                                                                    >
                                                                        Select
                                                                    </Button>
                                                                </Box>
                                                            </Box>
                                                        </Modal>
                                                    </>
                                                ) : (
                                                        <DataField id="selectDataset"
                                                            name="datasetId"
                                                            label="Select DataSet"
                                                        value={insituExtractorFormData.dataset.fieldValue}
                                                        readOnly={true}
                                                    />
                                                )}
                                            </FormControl>
                                        </Grid>   
                                    <Grid item xs={6}>
                                        <FormControl
                                            sx={{ m: 1 }}
                                            fullWidth
                                            variant={
                                                mode === constants.MODE.view ? "standard" : "outlined"
                                            }
                                        >
                                            <Autocomplete
                                                options={idpUsersProduction}
                                                onChange={(event, value) => {
                                                    let v = value as IUser;
                                                    if (v === null)
                                                        insituExtractorFormData.username.isError = true;
                                                    else
                                                        insituExtractorFormData.username.isError = false;
                                                    insituExtractorFormData.username.fieldValue = v.userName;
                                                }}
                                                getOptionLabel={(option) =>
                                                    option === undefined ? " " : option.userName
                                                }
                                                isOptionEqualToValue={(option, value) =>
                                                    option?.userName === value?.userName
                                                }
                                                value={functions?.getIUser(
                                                    insituExtractorFormData?.username.fieldValue
                                                )}
                                                disabled={
                                                    mode === constants.MODE.view
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        name="username"
                                                        label="Username"
                                                        required
                                                        value={insituExtractorFormData.username.fieldValue}
                                                        error={insituExtractorFormData.username.isError}
                                                    />
                                                )}
                                                    onBlur={() => {
                                                        setAutocompleteOpen(false);
                                                    }}
                                                    onFocus={() => {
                                                        setAutocompleteOpen(true);
                                                    }}
                                            />
                                        </FormControl>

                                    </Grid>

                                    <Grid item xs={6} >
                                        <FormControl
                                            sx={{ m: 1 }}
                                            fullWidth
                                            disabled={mode === constants.MODE.view ? true : false}
                                            variant={
                                                mode === constants.MODE.view ? "standard" : "outlined"
                                            }
                                            required
                                        >
                                            <InputLabel id="demo-simple-select-label">Criticality</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="criticality-simple-select"
                                                label="Criticality"
                                                name="criticality"
                                                onChange={handleDropdownChange}
                                                fullWidth
                                                value={insituExtractorFormData.criticality.fieldValue}
                                            >
                                                {constants.criticalities.map((item, index) => {
                                                    return (
                                                        <MenuItem
                                                            value={item.value}
                                                            key={index}
                                                            sx={{ borderTop: 1, borderColor: "grey.400" }}
                                                        >
                                                            <ListItemText
                                                                primary={item.title}
                                                                secondary={
                                                                    <>
                                                                        <b>{item.application}</b>
                                                                        <br />
                                                                        {item.availability}
                                                                        <br />
                                                                        <b>{item.upTime}</b>
                                                                    </>
                                                                }
                                                            />
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                            <Box display="flex" justifyContent="flex-end" m={0}>
                                                {mode !== constants.MODE.view ? (
                                                    <Button id="btnCancel" color="primary" variant="contained" onClick={goBack}>
                                                        Cancel
                                                    </Button>
                                                ) : ""}
                                                &nbsp;
                                                {mode === constants.MODE.view && isAdmin ? (
                                                <>
                                                        <Button id="btnEdit"
                                                        color="primary"
                                                        sx={{ ml: 1 }}
                                                        variant="contained"
                                                        onClick={editInsituCriticality}
                                                    >
                                                        Edit
                                                    </Button>
                                                </>
                                            ) : ""}
                                            &nbsp;

                                                {mode !== constants.MODE.view && (
                                                <Button id="6f01c207-08b1-4893-84ac-b1a88bae3bc4"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={createNewInsituExtractor}
                                                    disabled={disableSaveBtn}
                                                >
                                                    Save
                                                </Button>
                                            )}
                                                &nbsp;
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={4}>
                                    {mode === "View" ? (
                                        <>
                                            <Grid item xs={6}>
                                                <Box display="flex" justifyContent="flex-start">
                                                    <br />
                                                    Updated By: {updatedBy}
                                                </Box>
                                                <Box display="flex" justifyContent="flex-start">
                                                    Updated On: {updatedOn}
                                                </Box>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Box display="flex" justifyContent="flex-end">
                                                    <br />
                                                    Created By: {createdBy}
                                                </Box>
                                                <Box display="flex" justifyContent="flex-end">
                                                    Created On: {createdOn}
                                                </Box>
                                            </Grid>
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </Grid>
                            </>
                        )}
                    </Form>
                </div>
            </Formik>
        </>
    );
};

export default InsituExtractorForm;
